import { FC, SVGProps } from 'react';

export const ThreeDotsMenuHorizontalIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 14C5.89543 14 5 14.8954 5 16C5 17.1046 5.89543 18 7 18C8.10457 18 9 17.1046 9 16C9 14.8954 8.10457 14 7 14ZM14.3333 16C14.3333 14.8954 15.2288 14 16.3333 14C17.4379 14 18.3333 14.8954 18.3333 16C18.3333 17.1046 17.4379 18 16.3333 18C15.2288 18 14.3333 17.1046 14.3333 16ZM23.6667 16C23.6667 14.8954 24.5621 14 25.6667 14C26.7712 14 27.6667 14.8954 27.6667 16C27.6667 17.1046 26.7712 18 25.6667 18C24.5621 18 23.6667 17.1046 23.6667 16Z"
			fill="currentColor"
		/>
	</svg>
);
